module.exports = __webpack_public_path__ + "img/songjianliucheng.1a441e3d.jpg";